const OnboardingBackground: React.FC = (props) => {
  return (
    <img src="/images/onboarding-background.png" alt="Onboarding Background" {...props} />
  );
};

export default OnboardingBackground;
